<template>
  <div class="important-days-app">
    <form
      id="formCalendarEvents"
      class="important-days-app__fields"
      onsubmit="event.preventDefault()"
    >
      <base-fields>
        <template #title>
          {{ text.data }}
        </template>
        <template #content>
          <base-field
            v-model="userData.name"
            type="text"
            name="name"
          >
            {{ text.name }}
          </base-field>
          <base-field
            v-model="userData.phone"
            type="tel"
            name="phone"
          >
            {{ text.phone }}
          </base-field>
          <base-field
            v-model="userData.email"
            type="email"
            name="email"
            :invalid="errors['email']"
            required
          >
            {{ text.email }}
          </base-field>
        </template>
      </base-fields>
      <base-fields>
        <template #title>
          {{ text.dates }}:
        </template>
        <template #title-second>
          {{ text.date }}:
        </template>
        <template #content>
          <important-date
            v-for="(calendarEvent, index) in userData.calendarEvents"
            :key="calendarEvent.id"
            :text="text"
            :value="calendarEvent"
            :not-removable="userData.calendarEvents.length === 1"
            :invalid="eventErrors"
            @input="updateCalendarEvents(index, $event)"
            @remove="removeCalendarEvent"
          />
        </template>
      </base-fields>
    </form>
    <div class="important-days-app__buttons">
      <base-button
        view="secondary"
        @click="addCalendarEvent"
      >
        <img
          width="26"
          height="26"
          :src="iconPlus"
          alt=""
        >
        {{ text.more }}
      </base-button>
      <base-button
        type="submit"
        form="formCalendarEvents"
        @click="saveCalendarEvents"
      >
        {{ text.save }}
      </base-button>
    </div>
    <fancy-modal
      :is-show="showModal"
      :data="successData"
      @destroy="cleanData"
    />
  </div>
</template>

<script>
import BaseField from './base/base-field'
import BaseFields from './base/base-fields'
import ImportantDate from './important-date'
import iconPlus from './images/icon-plus.svg'
import BaseButton from './base/base-button'
import FancyModal from './fancy-modal'

export default {
  name: 'ImportantDaysApp',
  components: {FancyModal, BaseButton, ImportantDate, BaseFields, BaseField},
  props: {
    text: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      userData: {
        name: null,
        phone: null,
        email: null,
        calendarEvents: [
          {
            id: Date.now(),
            name: null,
            date: null
          },
        ],
      },
      iconPlus,
      successData: null,
      showModal: false,
      errors: {}
    }
  },
  computed: {
    eventErrors() {
      return [{'event_name': this.errors['event_name']}, {'event_date': this.errors['event_date']}]
    }
  },
  watch: {
    userData: {
      handler() {
        this.cleanErrors()
      },
      deep: true
    }
  },
  methods: {
    updateCalendarEvents(index, value) {
      this.$set(this.userData.calendarEvents, index, value)
    },
    removeCalendarEvent(id) {
      this.userData.calendarEvents = this.userData.calendarEvents.filter(item => item.id !== id)
    },
    addCalendarEvent() {
      this.userData.calendarEvents.push({
        id: Date.now(),
        name: null,
        date: null
      })
    },
    cleanData() {
      this.userData.name = null
      this.userData.phone = null
      this.userData.email = null
      this.userData.calendarEvents = [
        {
          id: Date.now(),
          name: null,
          date: null
        }
      ]
      this.successData = null
      this.showModal = false
    },
    cleanErrors() {
      this.errors = {}
    },
    async saveCalendarEvents() {
      const response = await fetch('/index.php?route=information/important_day/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.userData)
      })
      const {data, errors} = await response.json()
      if (data) {
        this.successData = data
        this.showModal = true
      } else if (errors) {
        this.errors = errors
      }
    },
  }
}
</script>

<style lang="scss">
.important-days-app {
  &__fields {
    display: grid;
    gap: 26px;
  }

  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    margin-top: 42px;
  }


  @media (max-width: 426px) {
    &__buttons {
      grid-template-columns: 1fr;
      gap: 24px;
    }
  }
}
</style>
